import { render, staticRenderFns } from "./redConstruction.vue?vue&type=template&id=20b0f99c&scoped=true&"
import script from "./redConstruction.vue?vue&type=script&lang=js&"
export * from "./redConstruction.vue?vue&type=script&lang=js&"
import style0 from "./redConstruction.vue?vue&type=style&index=0&id=20b0f99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0f99c",
  null
  
)

export default component.exports